module.exports = __webpack_public_path__ + "img/logo.ec853828.png";